const CapitaliseWords = (text, fallback = "Not Available") => {
  if (text === null || text === undefined || text.trim() === "") {
    return fallback;
  }
  if (typeof text !== "string") {
    return fallback;
  }
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export default CapitaliseWords;
